import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SettingsNotificationRuleEffects } from './settings-notification-rule.effects';
import { FEATURE_KEY, reducer } from './settings-notification-rule.reducer';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature(FEATURE_KEY, reducer),
        EffectsModule.forFeature([SettingsNotificationRuleEffects]),
    ],
})
export class SettingsNotificationRuleDataAccessModule {}
